import type { NavigationBarV1Attributes } from '@/features/navigation-bar-v1/navigation-bar-v1-type';

import { Link, RawImage } from '@/core/features';
import color from '@/core/features/styles/color';

export type NavigationBarProps = NavigationBarV1Attributes;

export default function NavigationBarV1Desktop({ items }: NavigationBarProps) {
    return (
        <nav
            className={
                'navigationBar width-100 padding-10 line-height-18 text-white flex gap-10 align-center bg-check24Blue overflow-hidden'
            }
        >
            {items.map((item) => {
                return (
                    <Link
                        className={'navigationLink min-width-fit-content'}
                        href={item.linkUrl}
                        key={item.title}
                        linkType={'vertical'}
                        relType={'follow'}
                    >
                        <div
                            className={
                                'navigationItem padding-left-15 padding-right-15 text-nowrap line-height-32 font-size-14 flex gap-10 align-center border-transparent border-radius-20'
                            }
                            style={
                                item.isHighlighted
                                    ? {
                                          backgroundColor: color('white-01'),
                                          borderColor: color('white'),
                                      }
                                    : {}
                            }
                        >
                            <div className={'navigationItemIcon flex align-center shrink-0'}>
                                <RawImage
                                    alt={`${item.title} icon`}
                                    fetchPriority={'high'}
                                    height={32}
                                    preload={true}
                                    style={{
                                        padding: item.padding ?? undefined,
                                    }}
                                    url={item.iconUrl}
                                    // width={32} // TODO: Flug + Hotel padding 3px 6px 3px 0px + other optimizations
                                />
                            </div>
                            {item.title}
                        </div>
                    </Link>
                );
            })}
            <style jsx>{`
                .navigationBar {
                    height: 42px;
                    padding-left: 35px;
                    -webkit-font-smoothing: auto;
                }

                /* Wireframe Breakpoint */
                @media (max-width: 1280px) {
                    .navigationBar {
                        padding-left: 10px;
                    }
                }

                :global(.navigationBar > a:focus) > .navigationItem {
                    background-color: ${color('white-01')};
                }

                .navigationItem {
                    height: 34px;
                }

                .navigationItem:hover {
                    background-color: ${color('white-01')};
                }

                @media (max-width: 1540px) {
                    .navigationItemIcon {
                        display: none;
                    }
                }

                .navigationLink:focus > .navigationItem {
                    background-color: ${color('white-01')};
                }
            `}</style>
        </nav>
    );
}
